import { useAuthentication } from '~/hooks/useAuthentication';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from './query-schema';
import { PropsWithChildren } from 'react';

export function RecordTableWrapper({ children }: PropsWithChildren) {
  const { user, isSuperUser } = useAuthentication();
  const { values } = useFilterForm(querySchema.parse);

  const canManageRecords = isSuperUser || values.district_id === user?.permissions.districts_admin[0].id;

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Viktklass</Table.Col>
          <Table.Col as="th">Namn</Table.Col>
          <Table.Col as="th">Förening</Table.Col>
          <Table.Col as="th">Kroppsvikt</Table.Col>
          <Table.Col as="th">Resultat</Table.Col>
          <Table.Col as="th">Datum</Table.Col>
          {canManageRecords && <Table.Col />}
        </Table.Row>
      </Table.Head>
      <Table.Body>{children}</Table.Body>
    </Table>
  );
}
